module.exports = __webpack_public_path__ + "static/media/bb8-person_outline-24px.f946cb5b.svg";